export class ModelAdapter<Entity> {
    constructor(data: Entity) {
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const value = data[key];
                (this as any)[key] = value;
            }
        }
    }
}